// extracted by mini-css-extract-plugin
module.exports = {"header":"Artist_header__1k8cq","headerbg":"Artist_headerbg__28Te7","headercontent":"Artist_headercontent__3ox2Q","img":"Artist_img__1WMn0","grid":"Artist_grid__lvq2g"};